import { render, staticRenderFns } from "./POS.vue?vue&type=template&id=8d40ad80&scoped=true&"
import script from "./POS.vue?vue&type=script&lang=ts&"
export * from "./POS.vue?vue&type=script&lang=ts&"
import style0 from "./POS.vue?vue&type=style&index=0&id=8d40ad80&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d40ad80",
  null
  
)

export default component.exports